export default "__VITE_ASSET__CNo9eLVD__"